var map = {
	"./1.png": "55d5",
	"./2.png": "e8c3",
	"./3.png": "1591",
	"./4.png": "16bc",
	"./5.png": "7fe1",
	"./6.png": "ded3",
	"./7.png": "4314"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3b3";